/** And "Enum" for the "Persona Edu Converge" (grade school/college) the user has chosen in the signup flow */
export default class UnifiedSignupGradeLevel {
  public readonly personaEduConv;

  public static gradeSchool = new UnifiedSignupGradeLevel({ val: 'Grade School (K-12)' });

  public static collegeOrUniversity = new UnifiedSignupGradeLevel({ val: 'College or University' });

  private static mappings: Record<string, UnifiedSignupGradeLevel> = {
    'Grade School (K-12)': UnifiedSignupGradeLevel.gradeSchool,
    'College or University': UnifiedSignupGradeLevel.collegeOrUniversity,
  };

  private constructor({ val }: { val: string }) {
    this.personaEduConv = val;
  }

  public static fromString(val: string | number | boolean): UnifiedSignupGradeLevel {
    const intent = UnifiedSignupGradeLevel.mappings[`${val}`];
    if (!intent) throw new Error(`Could not find persona edu converge with val: '${val}'`);
    return intent;
  }

  public compareTo(rhs: UnifiedSignupGradeLevel) {
    return this.personaEduConv === rhs.personaEduConv;
  }
}
